import { useLayoutEffect } from "react";

export const usePreload = (...props: string[]) => {

    useLayoutEffect(() => {
        const hoverImgPreload = () => {
            props.forEach((src) => {
                const img = new Image();
                img.src = src;
            })
        };
        hoverImgPreload();
    }, [props]);
}
